import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { removeUserToken } from "../../redux/reducer/auth.reducer";
import AlertsBellMenu from "./AlertsBellMenu";
import NavbarAccountMenu from "./NavbarAccountMenu";
import NavbarDate from "./NavbarDate";

const NavbarNavigationItems = () => {
  const dispatch = useAppDispatch();
  const { prenume, nume, username } = useAppSelector((state) => state.user);

  return (
    <div className="flex min-w-0 flex-1 items-center gap-1 sm:gap-3">
      <div className="flex min-w-0 flex-1 justify-center">
        <NavbarDate />
      </div>
      <div className="flex shrink-0 items-center gap-1 sm:gap-3">
        <AlertsBellMenu />
        <span aria-hidden="true" className="h-[28px] w-px bg-slate-200" />
        <NavbarAccountMenu
          firstName={prenume}
          lastName={nume}
          username={username}
          onLogout={() => dispatch(removeUserToken())}
        />
      </div>
    </div>
  );
};

export default NavbarNavigationItems;
